import type { TypographyProps } from '../typography';
import type { FieldVariant } from './types';

export const getFieldIconColor = (
  variant: FieldVariant,
  disabled: boolean = false,
): NonNullable<TypographyProps['color']> => {
  if (disabled) {
    return 'grey-light-opacity-40';
  }

  if (variant === 'danger') {
    return 'danger';
  }

  if (variant === 'accent') {
    return 'accent-alt';
  }

  if (variant === 'success') {
    return 'success';
  }

  return 'grey-light';
};
